import { useEffect, useRef } from 'react';

// Visibility-aware interval: pause polling when the tab is hidden so a
// left-open background tab doesn't hammer the API every N seconds forever.
// Calls fn() once on mount, then every intervalMs while the tab is visible.
export function usePolling(fn, intervalMs = 15000) {
  const fnRef = useRef(fn);
  fnRef.current = fn;

  useEffect(() => {
    const tick = () => {
      if (document.visibilityState === 'visible') fnRef.current();
    };
    tick();
    const id = setInterval(tick, intervalMs);
    document.addEventListener('visibilitychange', tick);
    return () => {
      clearInterval(id);
      document.removeEventListener('visibilitychange', tick);
    };
  }, [intervalMs]);
}
